<div class="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--signin m-login--2 m-login-2--skin-2 ng-touched img"
	id="m_login" style="background-image: url(../../../assets/app/media/img/bg/bg_login.svg); height: 100vh;">
	<div class="m-grid__item m-grid__item--fluid">
		<div class="m-login__container m-login__wrapper">
			<div class="row" style="margin-top: 80px;">
				<div class="col-md-2"></div>
				<div class="col-md-3 m_logo">
					<div class="row">
						<div class="col-md-6  login_logo">
							<div class="m-login__logo m_login_logo">
								<img src="{{Logo}}">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12 login_left_text ">
							<div class="m-portlet__head-text m_portlet_head_text"  style="color: #333E49; font-size: 35px;"> e-Dönüşüm
								Portalı </div>
						</div>
					</div>
				</div>
				<div class="col-md-3" style="max-width: 430px;">
					<div class="m-login__signin m_login_signin" *ngIf="!authenticationStatus">
						<div class="m-login__head">
							<h3 class="m-login__title m_login_title" style="color: #333E49; font-size: 30px; 
							margin-bottom:20px ;margin-top: 10px;
							  font-family: Roboto;font-weight: bold;;"> Giriş Yap </h3>
						</div>
						<form (ngSubmit)="f.form.valid && signin()" #f="ngForm" class="m-login__form m-form">
							<ng-template #alertSignin></ng-template>
							<div class="form-group ">
								<label for="usernama"
									style="font-family: Dubai Medium;font-size: 16px;color: #333E49;">Kullanıcı
									Adı</label>
								<div class="m-input-icon m-input-icon--left">
									<span style="padding-left: 5px;padding-top: 10px;"
										class="m-input-icon__icon m-input-icon__icon--left dateIcon">
										<img src="../../../assets/app/media/img/icons/username.svg" alt="*">
									</span>
									<input class="form-control m-input" type="text" placeholder="Kullancı Adı"
										id="username" style="height:45px;
									background-color: #E4E5EB;border-style: none !important; border-radius: 10px;
									padding-left: 40px !important;" name="username" [(ngModel)]="model.username" autocomplete="off">
								</div>
							</div>
							<div class="form-group">
								<label for="usernama"
									style="font-family: Dubai Medium;font-size: 16px;color: #333E49;">Şifre</label>
								<div class="m-input-icon m-input-icon--left">
									<span style="padding-left: 5px;padding-top: 10px;"
										class="m-input-icon__icon m-input-icon__icon--left dateIcon">
										<img src="../../../assets/app/media/img/icons/password.svg" alt="*">
									</span>
									<input class="form-control m-input m-login__form-input--last " type="password"
										style="height:45px;
									background-color: #E4E5EB;border-style: none !important; border-radius: 10px;
									padding-left: 40px !important;" placeholder="Şifre" name="password" [(ngModel)]="model.password"
										autocomplete="on">
								</div>
							</div>
							<div class="form-group m-form__group" *ngIf="captchaCode !== '' && captchaCode !== null">
								<div style="float: left; width: 60%">
									<input class="form-control m-input" type="text" placeholder="Güvenlik Kodu"
										name="captchaText" [(ngModel)]="captchaText" autocomplete="off">
								</div>
								<div style="float: left; width: 30%">
									<img src="data:image/png;base64,{{captchaCode}}"
										style="height: 50px;width: 100px;margin-top: 20px;margin-left: 10px;" />
								</div>
								<div style="float: right; width: 10%">
									<a class="btn btn-outline-metal m-btn m-btn--icon m-btn--icon-only"
										style="color: #fff;margin-top: 20px;height: 50px;width: 100%;background: #7f8395;margin-left: -10px;"
										(click)="GetReCaptcha()">
										<i class="fa fa-history"></i>
									</a>
								</div>
								<div style="clear: both;"></div>
							</div>
							<div class="row m-login__form-sub">
								<div class="col m--align-left m-login__form-left">
									<a id="m_login_forget_password" (click)="PasswordForget()" class="m-link"
										style="cursor: pointer;color: #333E49;font-size: 16px;font-family: Dubai Medium; margin-left: 15px;"
										#ChangePasswordButton> Şifremi Unuttum! </a>
								</div>
								<div class="col m--align-right m-login__form-right">
								</div>
							</div>
							<div class="m-login__form-action text-right">
								<button id="m_login_signin_submit" class="btn  m-btn--air  btn-md m-btn m-btn--custom "
									[disabled]="loading"
									[ngClass]="{'m-loader m-loader--right m-loader--light': loading}" style="width: 150px;height: 40px; font-size: 15px; 
								color: #333E49;border-radius: 10px;
								font-weight: bold;"> Giriş Yap <span style="padding-left: 10px;">
										<img src="../../../assets/app/media/img/icons/login_enter.svg" alt="*">
									</span>
								</button>
							</div>
						</form>
					</div>
					<div class="m-login__forget-password" style="margin-top: 20px;">
						<div class="m-login__head">
							<h3 class="m-login__title m_login_title m--font-boldest m_font-boldest" style="font-family: Exo ExtraBold;font-size: 25px;
						color: #333E49;"> Şifremi Unuttum! </h3>
							<div>
							</div>
						</div>
						<form class="m-login__form m-form" style="margin-top: 10px;">
							<ng-template #alertForgotPass></ng-template>
							<div class="form-group m-form__group" *ngIf="SendMailStatus === 0">
								<label for="m_mail"
									style="font-family: Dubai Medium;font-size: 16px;color: #333E49;">E-mail</label>
								<div class="m-input-icon m-input-icon--left">
									<span style="padding-left: 5px;padding-top: 5px;"
										class="m-input-icon__icon m-input-icon__icon--left dateIcon">
										<img src="../../../assets/app/media/img/icons/mail.svg" alt="*">
									</span>
									<input class="form-control m-input" type="text"
										placeholder="Şifrenizi sıfırlamak için e-posta adresinizi girin" name="email"
										[(ngModel)]="forgetModel.Email" #email="ngModel" id="m_email" autocomplete="off"
										style="height:45px;
									background-color: #E4E5EB;border-style: none !important; border-radius: 10px;
									padding-left: 40px !important;padding-left:40px;">
								</div>
							</div>
							<div class="form-group m-form__group" *ngIf="SendMailStatus === 1">
								<span> Güvenlik Kodu : {{forgetModel.EmailCode}} </span>
								<!-- <input class="form-control m-input" type="text" placeholder="E-mail Kod" name="EMailKey"
							[(ngModel)]="forgetModel.EmailCode" id="EMailKey" autocomplete="off"> -->
							</div>
							<div class="form-group m-form__group" *ngIf="SendMailStatus === 1">
								<input class="form-control m-input" placeholder="Şifre" maxlength="10" type="password"
									[(ngModel)]="forgetModel.PasswordHashNew" id="PasswordHashNew"
									name="PasswordHashNew" autocomplete="on" />
							</div>
							<div class="form-group m-form__group" *ngIf="SendMailStatus === 1">
								<input class="form-control m-input" placeholder="Şifre Tekrar" maxlength="10"
									type="password" [(ngModel)]="forgetModel.PasswordHashNewAgain"
									id="PasswordHashNewAgain" name="PasswordHashNewAgain" autocomplete="on" />
							</div>
							<div class="m-login__form-action" style="margin-top: 10px; float: right;">
								<button id="m_login_forget_password_submit"
									class="btn m-btn--air btn-info btn-lg m-btn m-btn--custom" [disabled]="loading"
									(click)="PasswordChangeClick()"
									[ngClass]="{'m-loader m-loader--right m-loader--light': loading}"
									style="background-color: #484C6E; height: 40px;border-radius: 10px;"> Gönder
								</button>
								<button id="m_login_forget_password_cancel"
									class="btn m-btn--air btn-danger btn-lg m-btn m-btn--custom" [disabled]="loading"
									(click)="PasswordForget()" #CancelForget
									style="background-color: #ADB0C9; width:100px;height: 40px;border-radius: 10px;">
									Geri </button>
							</div>
						</form>
					</div>
					<div class="m-login__authentication" *ngIf="authenticationStatus">
						<div class="m-login__head">
							<h3 class="m-login__title m_login_title m--font-boldest " style="color: #172531;"> İki Adımlı Doğrulama
							</h3>
							<div class="m-login__desc" style="color: #172531;"> Portala giriş yapabilmek için
								telefonunuza gelen doğrulama kodunu giriniz. </div>
							<div>
							</div>
						</div>
						<form class="m-login__form m-form">
							<ng-template #alertSignin></ng-template>
							<div class="form-group m-form__group">
								<input class="form-control m-input" type="text" placeholder="Doğrulama Kodu" name="otp"
									[(ngModel)]="model.code" id="m_otp" autocomplete="off">
								<!-- [(ngModel)]="model.Code" #email="ngModel" id="m_otp" autocomplete="off"> -->
							</div>
							<div class="m-login__form-action">
								<!-- <button id="m_login_forget_password_submit"
							class="btn m-btn--pill m-btn--air btn-info btn-lg m-btn m-btn--custom" [disabled]="loading"
							(click)="PasswordChangeClick()"
							[ngClass]="{'m-loader m-loader--right m-loader--light': loading}" style="width: 120px;">
							Gönder
						</button> -->
								<button id="m_login_otp_submit"
									class="btn m-btn--pill m-btn--air btn-info btn-lg m-btn m-btn--custom"
									(click)="SignInOTP()" style="width: 120px;"> Gönder </button> &nbsp;&nbsp; <button
									id="m_login_forget_password_cancel"
									class="btn m-btn--pill m-btn--air btn-danger btn-lg m-btn m-btn--custom"
									[disabled]="loading" (click)="SecurityCodeForget()" #CancelSecurityCode
									style="width: 130px;">{{buttonText}} </button>
								<!-- <button [hidden]="true" (click) = "OpenPasswordFields()" #></button> -->
								<!-- <h2 [hidden]="!loading">
							Kalan Süre : {{counterInterval}}
						</h2> -->
							</div>
						</form>
					</div>
				</div>
				<div class="col-md-4"></div>
			</div>
		</div>
	</div>
	<div class="row m_footer" style="max-width: 99%;">
		<div class="col-md-1"></div>
		<div class="col-md-3">
			<div class="row">
				<div class="col-md-2">
					<h4>
						<a class="m-link  m--font-boldest m_font_boldest m_footer-title" [href]=vbtLink target="_blank">{{vbtText}}</a>
					</h4>
				</div>
				<div class="col-md-2">
					<h4>
						<a class="m-link  m--font-boldest m_font_boldest m_footer-title" [href]=contactLink target="_blank">{{contactText}}</a>
					</h4>
				</div>
				<div class="col-md-8">
					<h4>
						<a class="m-link m--font-boldest m_font_boldest m_footer-title" [href]=kvkkLink target="_blank">{{kvkkText}}</a>
					</h4>
				</div>
			</div>
		</div>
	</div>
</div>